import {
  Checkbox as AntdCheckbox,
} from 'antd';
import React from 'react';

function Checkbox({ onChange, checked, ...props }) {
  return (
    <div
      className="custom-selection-cell
    rounded-full
    flex items-center justify-center p-2 cursor-pointer
    hover:bg-gray-100 hover:scale-105
    transition-all duration-200 ease-in-out"
      onClick={onChange}
      {...props}
    >
      <AntdCheckbox
        checked={checked}
        onChange={() => {}} // Handled by onClick above
        style={{
          lineHeight: 1,
        }}
      />

    </div>
  );
}

export default Checkbox;
